import { get } from '@client/lib/request';
import { TAB_FEMALE, TAB_MALE } from '@client/config/constants';

const TAB_TO_GENDER = {
    [TAB_FEMALE]: 'FEMALE',
    [TAB_MALE]: 'MALE',
};

const DEFAULT_GENDER = 'FEMALE';

export function getOpenCampaignsByType(type = '', { date } = { date: 'now' }) {
    const requestQuery = {
        gender: TAB_TO_GENDER[type] || DEFAULT_GENDER,
        date,
    };

    // TODO remove the 'mylounge' parameter
    return get(`/mylounge-api/mylounge/open/${type}`, requestQuery, 'mylounge');
}

export function getMyLounge(query = {}) {
    query.gender = TAB_TO_GENDER[query.activeTab] || 'FEMALE';

    const requestQuery = {
        gender: query.gender,
        activeTab: query.activeTab,
        date: query.date,
    };

    // TODO remove the 'mylounge' parameter
    return get(
        `/mylounge-api/mylounge${query.activeTab ? `/${query.activeTab}` : ''}`,
        requestQuery,
        'mylounge'
    );
}

export function getReco(tab) {
    const gender = TAB_TO_GENDER[tab] || DEFAULT_GENDER;

    return get('/mylounge-api/mylounge/reco', { gender });
}
